export default "__VITE_ASSET__DD4AQmm8__"